<template>
  <div :class="{'pt':data.project_type==1}" v-if="body_show">
    <div v-if="data.project_type!=1" class="men_infortop">
      <a @click="statistical_l"><img src="@a/logos.png" /></a>
    </div>
    <div v-else class="men_infortop_else"></div>
    <div class="project_main" v-if="score != ''" style="margin-top: 0">
      <router-link class="aac" :to="'/project_report?cid='+ cid + '&cpid=' + pid">
        <h2>{{name+project_doned}}</h2>
        <img :src="score" class="tb" />
      </router-link>
    </div>
    <div class="project_main" :class="{pvc: score == ''}">
      <h2>项目详情</h2>
      <p class="pj_pb" :class="{pj_hidden: (project.introduce.length>156) && pj_show}" v-html="project.introduce"></p>
      <a class="close_pj" v-show="project.introduce.length>156 && pj_show" @click="pj_show=false"></a>
    </div>
    <div class="project_main pjv" v-if="task.length>0">
      <h2>项目任务<span v-if="!data.project_type==1">（最迟完成时间：{{project.latest_time}}）</span></h2>
      <ul class="pro_ul">
        <li v-for="(item,index) in task" :key="index" class="clearfix">
          <div class="pro_ull clearfix">
            <span>T{{index+1}}</span>
            <div class="pro_ullr">
              <h3>{{item.name}}</h3>
              <h4 v-if="data.project_type==1">{{item.donedcount}}人 完成</h4>
              <h4 v-else>{{item.donedcount}}/{{data.totalcount}}人 已完成</h4>
            </div>
          </div>
          <div v-if="item.isclickable==1">
            <router-link :to="url_substying(item.skip) + '?cid=' + cid + '&pid=' + pid + '&id=' + item.id + '&name=' + project.name" class="a" v-if="item.status==0">做任务</router-link>
            <!-- 判读是否是试学 -->
            <router-link :to="url_substying(item.skip) + '?cid=' + cid + '&pid=' + pid + '&id=' + item.id + '&name=' + project.name" class="a over" v-else-if="item.status!=0 && data.project_type==1">重做</router-link>
            <router-link :to="url_substying(item.skip) + '?cid=' + cid + '&pid=' + pid + '&id=' + item.id + '&name=' + project.name" class="a over" v-else>已完成</router-link>
          </div>
          <div v-else>
            <div class="on" @click="alerts">做任务</div>
          </div>
        </li>
        <li v-if="data.pmqhref != ''" class="clearfix">
          <div class="pro_ull clearfix">
            <img src="@a/p3_eggs.png" style="width:1.16rem;height:1.16rem;float: left;vertical-align: middle;" />
            <div class="pro_ullr" style="margin-left: 0;">
              <h3>项目彩蛋</h3>
              <h4>{{data.donedPmqNum}}/{{data.totalcount}}人 已完成</h4>
            </div>
          </div>
          <router-link :to="data.pmqhref" class="a" v-if="data.pmqstatus==1">项目彩蛋</router-link>
          <router-link :to="data.pmqhref" class="a over" v-else>查看报告</router-link>
        </li>
      </ul>
    </div>
    <div class="project_main pjv" v-if="subject.length>0">
      <h2>项目课程</h2>
      <ul class="pro_ul">
        <li v-for="(item,index) in subject" :key="index" class="clearfix">
          <div class="pro_ull clearfix">
            <span>L{{index+1}}</span>
            <div class="pro_ullr">
              <h3>{{item.name}}</h3>
              <h4 v-if="data.project_type==1">{{item.donedcount}}人 试学</h4>
              <h4 v-else>{{item.donedcount}}/{{data.totalcount}}人 已完成</h4>
            </div>
          </div>
          <router-link class="a over" v-if="item.status == 1" :to="{
                path: '/course_content',
                query: {
                  'id': item.id,
                  'cid': cid,
                  'cpid': pid,
                  'pdk': routArg.pdk,
                  'aspx': routArg.aspx,
                  'source': routArg.source
                }
              }">重学</router-link>
          <router-link class="a" v-else :to="{
                path: '/course_content',
                query: {
                  'id': item.id,
                  'cid': cid,
                  'cpid': pid,
                  'pdk': routArg.pdk,
                  'aspx': routArg.aspx,
                  'source': routArg.source
                }
              }">{{data.project_type==1?'试学':'去学习'}}</router-link>
        </li>
      </ul>
    </div>
    <div class="project_main pjv" v-if="score != ''">
      <h2>项目攻略</h2>
      <router-link tag="div" :to="'/faq_list?cpid=' + pid + '&cid=' + cid " class="decult project_details">
        <div class="decult_t">
          <h3>帮助你攻克任务难点</h3>
          <h4>打开它，就多收获一个攻克任务的法宝</h4>
        </div>
        <p class="a">查看 ></p>
      </router-link>
    </div>
    <div class="project_main" v-if="tools.faq || tools.href || tools.valuation || tools.selfcheck || (cid>1 && tools.glossary)">
      <h2>项目工具箱</h2>
      <ul class="zil_ul clearfix">
        <li v-if="tools.faq">
          <router-link :to=" '/faq_list?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil00.png" />
            <p>项目攻略</p>
          </router-link>
        </li>
        <li v-if="tools.href">
          <router-link :to=" '/further_reading?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil11.png" />
            <p>扩展阅读</p>
          </router-link>
        </li>
        <li v-if="tools.valuation">
          <router-link :to=" 'valuation?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil22.png" />
            <p>大神导师团</p>
          </router-link>
        </li>
        <li v-if="tools.selfcheck">
          <router-link :to="'check_content?id=' + data.checklistid + '&cid=' + cid ">
            <img src="@a/zil33.png" />
            <p>自查清单</p>
          </router-link>
        </li>
        <li v-if="cid>1 && tools.glossary">
          <router-link :to=" 'difficult_words?cpid=' + pid + '&cid=' + cid ">
            <img src="@a/zil44.png" />
            <p>难词表</p>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="project_main" v-if="data.project_type != 1">
      <h2>
        项目成员
        <span class="message" v-if="replycount > 0" @click="toProjectReport(userDetail.id)">{{replycount}}&nbsp;条新消息</span>
        <span class="all-homework" @click="homeWorkHandle">全部作业&nbsp;<i class="iconfont icon-you"></i></span>
      </h2>
      <ul class="member_ul clearfix">
        <li @click="toProjectReport(userDetail.id)">
          <img :src="userDetail.headimgurl" />
          <p>{{userDetail.name}}</p>
          <span class="on" v-if="replycount > 0">{{replycount}}</span>
        </li>
        <li v-if="groupmember.length>0" v-for="(item,index) in groupmember" :key="index" @click="toProjectReport(item.uid)">
          <img :src="item.headimgurl" />
          <p>{{item.name}}</p>
          <span class="on" v-if="item.replycount > 0">{{item.replycount}}</span>
        </li>
      </ul>
    </div>
    <!-- 解锁更多项目 -->
    <van-button v-if="data.project_type==1" @click="doUnlockProject" class="unlock-project" type="default">解锁更多项目</van-button>
    <!-- 弹框 -->
    <!-- 自己 -->
    <!-- <van-popup class="radius" :close-on-click-overlay="true" v-model="showModul">
      <div class="pop pr">
        <img src="@a/task-3-pop.png" alt="" />
        <p class="tips pa">嘿！ {{userDetail.name}}</p>
      </div>
    </van-popup> -->
    <!-- 公用音频底部 -->
    <public-foot-audio :footerShow="footer_show"></public-foot-audio>
    <!-- 引入卡片弹窗 -->
    <public-pop :imgUrl="data.sharebuy_placard" :cid="cid" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按保存分享，每入学1位您可获得80元奖学金'" :type="1"></public-pop>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="details_cid" :use_id="use_id" :source="source" :sharetype="sharetype" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <!-- 解锁更多项目 -->
    <van-popup v-model="unlock_project" position="bottom">
      <div class="share_order">
        <div class="share-content">
          <img src="@a/sha2.png" class="close" alt="" @click="unlock_project=false" />
          <div class="clearfix"></div>
          <h2>请选择合适的课程</h2>
          <van-radio-group :class="['order_group',!item.sign?'radio_group_over':'','clearfix']" v-for="(item,index) in courseData.list" :key="index" v-model="radio" :disabled="!item.sign?true:false">
            <van-radio class="clearfix" :name="item.id">
              {{item.begintime}} 开课
            </van-radio>
          </van-radio-group>
          <div class="clearfix"></div>
        </div>
        <!-- 优惠 -->
        <div v-if="is_red" class="discounts">
          <h2>课程优惠</h2>
          <van-radio-group v-for="(item,index) in order_group" :key="index" class="discounts-radio" v-model="use_id">
            <van-cell-group>
              <van-cell clickable>
                <van-radio slot="right-icon" :name="item.id" />
                <template slot="title">
                  {{item.name}}<span>- ￥{{item.price}}</span>
                </template>
              </van-cell>
              <p class="discounts-small">不可与其它优惠同时享受</p>
            </van-cell-group>
          </van-radio-group>
        </div>
        <!-- 立即报名 -->
        <div class="unlock-btn">
          <a class="unlock-btn-left">
            <div>
              <span v-if="use_id" class="money">
                <s>￥{{courseprice}}</s>
              </span>
              <span v-else class="money">
                ￥{{courseprice}}
              </span>
              <span>仅剩席位{{surplus}}</span>
            </div>
          </a>
          <a @click="signHandle" v-if="surplus>0" class="unlock-btn-right">
            立即报名 ￥{{order_price}}
          </a>
          <!-- <a @click="signHandle" v-else-if="surplus>0 && !use_id" class="unlock-btn-right">
            立即报名
          </a> -->
          <a class="unlock-btn-right on" v-else>本期已满</a>
        </div>
      </div>
    </van-popup>
    <!-- 未关注弹窗 -->
    <van-popup :close-on-click-overlay="false" v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">{{data.user_detail.name}}你好！您已成功报名{{data.courseName}}，为了不和组织失联，请关注下方二维码。</h3>
        <h4>识别或扫描二维码</h4>
        <img src="@a/carrer.png" />
        <h4>已关注的看官自动忽略</h4>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  projectdetail,
  statistic_next,
  coursedetail
} from "@/api/course";
import {
  statistics
} from "@/api/public";
import {
  shareCon
} from "@/utils/wxconfig";
import {
  queryString,
  getStorage,
  setStorage
} from "@/utils/tools";
export default {
  data() {
      return {
        cid: "",
        pid: "",
        data: {},
        body_show: false,
        score: '',
        name: "",
        project_doned: "",
        project: {},
        pj_show: true,
        task: [],
        subject: [],
        groupmember: [],
        footer_show: true,
        replycount: 0,
        userDetail: {},
        showModul: false,
        routArg: {},
        bid: null,
        // 解锁更多项目
        unlock_project: false,
        courseprice: null,
        originalprice: null,
        order_group: [],
        use_id: null,
        radio: '',
        order_price: '',
        courseData: {},
        sharetype: "",
        is_red: false,
        surplus: null,
        details_cid: null,
        assistant_show: false,
        // 项目工具箱
        tools:{}
      }
    },
    props: {
      pulldata: Object
    },
    methods: {
      // 解锁更多项目
      doUnlockProject() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        coursedetail({
            bid: this.bid
          })
          .then((data) => {
            this.courseData = data;
            this.sharetype = data.sharetype;
            // 清除加载
            this.$toast.clear();
            this.is_red = !data.redType && data.redPrice != '';
            // 课程期数
            for (let arg of data.list) {
              if (arg.selected) {
                this.courseprice = arg.courseprice;
                this.originalprice = arg.originalprice;
                this.surplus = arg.surplus;
                this.details_cid = String(arg.id);
                this.radio = arg.id;
                this.order_price = arg.courseprice;
              }
            };
            if (this.is_red && this.courseData.otheractivity) {
              // 后台红包只取最大，所以默认只有一个
              this.order_group[0] = {
                name: "红包折扣",
                price: this.courseData.redPrice.use_money,
                id: this.courseData.redPrice.use_id
              };
            }

            if (this.is_red) {
              this.order_price = (this.originalprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
            }

            shareCon("course", this);
            // 神策统计
            sensors.track('projectDetails', {
                classification: data.bigcoursename,
                classification_id: this.$route.query.bid,
                channel_name: this.source || '',
                course_id: this.cid,
                course_name: data.coursename,
                share_user_id: this.pdk || '',
                course_discount_price: data.courseprice,
                course_original_price: data.originalprice,
                course_starttime: data.begintime,
                // 新增
                course_user_type: data.ishavedbuy ? "已付费" : "未付费"
              })
              // 显示解锁项目弹窗
            this.unlock_project = true;

          });
      },
      // 解锁更多项目'立即报名'触发
      signHandle() {
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.courseData.bigcoursename,
          classification: this.courseData.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.courseData.coursename,
          course_discount_price: this.courseData.courseprice,
          course_original_price: this.courseData.originalprice,
          course_starttime: this.courseData.begintime
        });
        // 把神策数据存到本地缓存
        let godPolicy = {
          course_id: this.cid,
          classification: this.courseData.bigcoursename,
          course_name: this.courseData.coursename,
          course_discount_price: this.courseData.courseprice,
          course_original_price: this.courseData.originalprice,
          course_starttime: this.courseData.begintime
        };
        setStorage('godPolicy', 'godPolicy', godPolicy);
        if (this.courseData.refunding) {
          this.$toast("有退款订单，不能购买！");
        } else {
          if ((this.courseData.shareinfo || this.is_red) && !this.unlock_project) {
            this.unlock_project = true;
          } else {
            if (this.courseData.mobilestatus) {
              // 是否需要验证验证码
              this.$refs.handle.need_verify = this.courseData.need_verify || false;
              // 判断用户手机号是否已验证
              this.$refs.handle.phone = this.courseData.userdetail.mobile ? this.courseData.userdetail.mobile : null;
              this.$refs.handle.show = true;
            } else {
              this.$refs.handle.pay()
            }
          }

        }

      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      pullData(data) {
        if (data.project_type == 1) {
          document.title = decodeURI('试学项目');
        } else {
          document.title = data.project.name;
        }
        this.body_show = true;
        this.data = data;
        this.score = data.score;
        this.bid = data.bid;
        this.name = data.project.name;
        this.project_doned = data.project_doned_status;
        this.cid = data.cid;
        this.pid = data.pid;
        this.project = data.project;
        this.task = data.task;
        this.subject = data.subject;
        this.groupmember = data.groupmember;
        this.replycount = data.replycount;
        this.userDetail = data.user_detail;
        // 项目工具箱
        this.tools = data.tools;
        this.cacheUserConfig = {
          pdk: data.pdk,
          aspx: data.aspx
        };
        // 判断是否关注
        // if (!data.subscribe && data.project_type == 0) {
        //   this.assistant_show = true;
        // }
        shareCon("course", this);
        let querys = this.$route.query;
        if (querys.source) {
          this.routArg['source'] = querys.source;
        }
        if (querys.pdk) {
          this.routArg['pdk'] = querys.pdk;
        }
        if (querys.aspx) {
          this.routArg['aspx'] = querys.aspx;
        }
      },
      statistic_() {
        statistic_next({
            cid: this.data.id
          })
          .then();
      },
      statistical_l() {
        statistics({
          type: "lefticon"
        }).then(data => {
          this.$router.push({
            path: '/index',
            query: {
              'pdk': this.routArg.pdk,
              'aspx': this.routArg.aspx,
              'source': this.routArg.source,
            }
          });
        });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        if (index < 0 || last < 0) {
          return url_;
        }
        let x = url_.substring(index, last);
        return x
      },
      alerts() {
        this.$toast("任务一、任务二完成之后，自动解锁任务三!");
      },
      onScroll() {
        window.onscroll = (ev) => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          let w = 100;
          if (t > w) {
            this.footer_show = false;
          } else {
            this.footer_show = true;
          }
        }
      },
      // 全部作业
      homeWorkHandle() {
        this.$router.push({
          path: '/all_homework', //跳转的路径
          query: { //路由传参时push和query搭配使用 ，作用时传递参数
            cpid: this.$route.query.cpid,
            cid: this.$route.query.cid
          }
        });
      },
      // 跳转报告页面
      toProjectReport(uid_) {
        this.$router.push({
          path: '/project_report_new',
          query: {
            cid: this.$route.query.cid,
            cpid: this.$route.query.cpid,
            uid: uid_
          }
        });
      },
      showModal() {
        let q = this.$route.query;
        let jsonData = window.localStorage.roject3_main;
        let result = jsonData ? JSON.parse(jsonData) : false;
        if (q.showModul == 'true' && !result.showModul) {
          this.showModul = true;
          window.localStorage.roject3_main = JSON.stringify({
            showModul: true
          });
        }
      }
    },
    created() {
      this.pullData(this.pulldata);
      this.showModal()

    },
    mounted() {
      this.onScroll()
    },
    watch: {

      radio(curVal, oldVal) {
        // 修改课程期数
        for (let arg of this.courseData.list) {
          if (arg.id == curVal) {
            this.courseprice = arg.courseprice;
            this.originalprice = arg.originalprice;
            this.surplus = arg.surplus;
            if (this.use_id) {
              this.order_price = (this.courseprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
            } else {
              this.order_price = arg.courseprice;
            }
          }
        };
        this.cid = String(curVal);
      },
      use_id(curVal, oldVal) {
        if (curVal) {
          this.order_price = (this.courseprice * 100 - this.courseData.redPrice.use_money * 100) / 100;
        } else {
          this.order_price = arg.courseprice;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.text-yellow {
  color: #F57F17;
}

.text-bold {
  font-weight: bold;
}

.men_infortop {
  width: 750px;
  line-height: 1;
  padding: changeRem(.4)+px changeRem(.6)+px;
  color: #EB5032;
  font-size: changeRem(.68)+px;
  text-align: left;
  a {
    display: inline-block;
    width: changeRem(4.8)+px;
    img {
      width: 100%;
    }
  }
}

.men_infortop_else {
  margin-top: 20px;
}

.project_main {
  padding: 30px;
  width: 100%;
  background: #fff;
  .aac {
    background-size: 100% 100%;
    text-align: right;
    width: 100%;
    height: changeRem(3.16)+px;
    display: block;
    background-image: url(../../../assets/project_details_header.png);
    -webkit-border-radius: changeRem(.16)+px;
    border-radius: changeRem(.16)+px;
    position: relative;
    h2 {
      position: absolute;
      font-size: changeRem(.68)+px;
      color: #FFFFFF;
      top: changeRem(.76)+px;
      left: changeRem(.6)+px;
      font-weight: normal;
      letter-spacing: 1px;
    }
    img {
      width: changeRem(2.96)+px;
      height: changeRem(2.24)+px;
      margin: 0 auto;
      margin-top: changeRem(.6)+px;
      margin-right: changeRem(1.2)+px;
    }
  }
  .message {
    font-size: 24px;
    color: #EB5032;
    padding: 8px 13px;
    border: 1px solid #EB5032;
    margin-left: 24px;
    font-weight: normal;
    cursor: pointer;
  }
  .all-homework {
    position: absolute;
    font-size: 24px;
    color: #EB5032;
    right: 30px;
    font-weight: normal;
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
}

.project_main {
  padding: changeRem(.6)+px;
  width: 100%;
  background: #fff;
  margin-top: changeRem(.4)+px;
  h2 {
    font-size: changeRem(.68)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    text-align: left;
    font-weight: bold;
    span {
      color: #EB5032;
      font-size: changeRem(.48)+px;
      vertical-align: middle;
    }
  }
  .pj_pb {
    font-size: changeRem(.52)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    width: 100%;
    text-align: justify;
    margin-top: changeRem(.56)+px;
    height: auto;
  }
  .pj_pb.pj_hidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    overflow: hidden;
    height: changeRem(6)+px;
  }
  .close_pj {
    display: block;
    margin: 0 auto;
    margin-top: changeRem(.4)+px;
    width: changeRem(.88)+px;
    height: changeRem(.6)+px;
    background: url(../../../assets/down_l.png) no-repeat top center;
    background-size: cover;
  }
  .zil_ul {
    margin: 0 auto;
    margin-top: changeRem(1)+px;
    li {
      width: 20%;
      margin-right: 0;
      float: left;
      text-align: center;
      a {
        display: block;
        width: 100%;
        height: 100%;
        img {
          width: changeRem(.96)+px;
          height: changeRem(.96)+px;
        }
        p {
          font-size: changeRem(.4)+px;
          color: #333;
          line-height: 40px;
          margin-top: 20px
        }
      }
    }
  }
  .member_ul {
    margin-top: changeRem(.8)+px;
    li {
      width: changeRem(1.2)+px;
      margin-right: 0;
      float: left;
      margin-right: changeRem(.5)+px;
      margin-bottom: changeRem(.2)+px;
      text-align: center;
      position: relative;
      img {
        width: changeRem(1.2)+px;
        height: changeRem(1.2)+px;
        border-radius: 50%;
      }
      p {
        font-size: 16px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }
      span {
        display: inline-block;
        position: absolute;
        height: 26px;
        line-height: 26px;
        top: -1px;
        right: -50%;
        background-color: #EB5032;
        color: #fff;
        border-radius: 50%;
        font-size: 20px;
      }
      span.on {
        padding: 0px 7px;
        top: -1px;
        right: -16px;
      }
    }
  }
}

.project_main.pvc {
  margin-top: 0;
}

.project_main.pjv {
  padding-bottom: changeRem(.2)+px;
  .pro_ul {
    width: 100%;
    li {
      line-height: changeRem(2.28)+px;
      width: 100%;
      color: #333;
      font-size: changeRem(.52)+px;
      border-bottom: 1px solid #ccc;
      .pro_ull {
        line-height: changeRem(2.28)+px;
        width: changeRem(10)+px;
        color: #333;
        font-size: changeRem(.52)+px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        text-align: justify;
        padding: changeRem(.6)+px 0;
        span {
          color: #EB5032;
          font-size: changeRem(.68)+px;
          line-height: changeRem(1.2)+px;
          float: left;
        }
        .pro_ullr {
          width: changeRem(8.7)+px;
          margin-left: changeRem(.4)+px;
          float: left;
          h3 {
            color: #333;
            font-size: changeRem(.52)+px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 100%;
            padding: changeRem(.05)+px 0;
            line-height: 1.1
          }
          h4 {
            color: #999;
            font-size: changeRem(.48)+px;
            margin-top: changeRem(.2)+px;
            line-height: 1.1
          }
        }
      }
      .a {
        display: block;
        width: changeRem(2.68)+px;
        height: changeRem(1.08)+px;
        line-height: changeRem(1.08)+px;
        background: rgba(235, 80, 50, 1);
        border-radius: changeRem(.56)+px;
        text-align: center;
        font-size: changeRem(.52)+px;
        color: #fff;
        float: right;
        margin-top: changeRem(.6)+px;
      }
      .a.over {
        background-color: #fff;
        border: 2px solid #EB5032;
        color: #EB5032;
      }
      .a.on {
        background-color: #ccc
      }
    }
    li:last-child {
      border-bottom: none;
    }
  }
  .decult {
    width: changeRem(13.8)+px;
    height: changeRem(4)+px;
    background: rgba(247, 247, 247, 1);
    box-shadow: 0px changeRem(.08)+px changeRem(.16)+px 0px rgba(204, 204, 204, 0.51);
    border-radius: changeRem(.16)+px;
    margin-top: changeRem(.84)+px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: changeRem(.8)+px;
    .decult_t {
      background: #fff;
      text-align: center;
      padding: changeRem(.5)+px 0;
      h3 {
        color: #EB5032;
        font-size: changeRem(.58)+px;
        line-height: changeRem(.8)+px;
        letter-spacing: changeRem(.1)+px;
      }
      h4 {
        color: #666;
        font-size: changeRem(.48)+px;
        line-height: changeRem(.6)+px;
        margin-top: changeRem(.3)+px;
      }
    }
    .a {
      color: #999;
      font-size: changeRem(.4)+px;
      text-align: right;
      float: right;
      margin-right: changeRem(.6)+px;
      line-height: changeRem(1.3)+px;
      width: 100%
    }
  }
}

.pop {
  font-size: 30px;
  width: 8rem;
  .tips {
    left: 80px;
    top: 180px;
    font-size: 0.26rem;
  }
  img {
    max-width: 100%;
  }
}

// 解锁更多项目
.pt {
  padding-bottom: 98px;
}

.unlock-project {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 34px;
  color: #fff;
  line-height: 98px;
  height: 98px;
  background-color: #EB5032;
  width: 100%;
}

.share_order {
  width: 100%;
  .share-content {
    padding: 30px 30px 0 30px;
  }
  img {
    float: right;
    width: 28px;
    margin: 0 30px 30px 30px;
  }
  h2 {
    color: #333;
    font-size: 34px;
    text-align: left;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .unlock-btn {
    position: relative;
    margin-top: 100px;
    padding-left: 214px;
    height: 98px;
    line-height: 98px;
    .unlock-btn-left {
      display: block;
      width: 214px;
      color: #666666;
      font-size: 24px;
      position: absolute;
      border-top: 1px solid #ccc;
      left: 0;
      bottom: 0;
      text-align: center;
      height: 98px;
      line-height: 1;
      div {
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        padding: 20px 0;
        span.money {
          display: inherit;
          font-size: 34px;
          color: #EB5032;
          line-height: 1;
        }
      }
    }
    .unlock-btn-right {
      background-color: #EB5032;
      color: #fff;
      text-align: center;
      display: block;
      font-size: 34px;
    }
    .unlock-btn-right.on {
      background-color: #cccccc;
    }
  }
}

.order_group {
  color: #EB5032;
  font-size: 26px;
  line-height: 70px;
  text-align: center;
  position: relative;
  float: left;
  width: 310px;
  border: 1px solid #EB5032;
  margin: 30px 0 0 0;
}

.order_group:nth-child(odd) {
  margin-left: 30px;
}

.order_group.radio_group_over {
  color: #999999;
  border-color: #ccc
}

.discounts {
  padding: 30px;
  margin-top: 80px;
  h2 {
    margin-bottom: 40px;
  }
  .discounts-radio {
    p {
      color: #999;
      font-size: 20px;
    }
    .van-cell {
      padding: 0;
      .van-cell__title {
        font-size: 26px;
        color: #333;
        display: flex;
        span {
          margin-left: auto;
          color: #EB5032;
          font-size: 26px;
          margin-right: 80px;
        }
      }
    }
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
</style>
<style lang="scss">
.order_group {
  .van-radio .van-radio__icon {
    bottom: 0;
    top: auto;
  }
  .van-icon.van-icon-success {
    position: absolute;
    bottom: 0;
    right: 0;
    height: auto;
  }
  .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
    width: 43px;
    height: 36px;
    background-image: url(../../../assets/radio_dw.png);
    background-size: cover;
    border-radius: 0;
    transition: .03s;
  }
  .van-radio__label {
    margin-left: 0;
    color: #EB5032;
    font-size: 26px;
  }
  .van-radio__icon.van-radio__icon--round .van-icon.van-icon-success {
    color: #fff;
    border-color: transparent;
    background-color: transparent;
    border: 0px;
  }
  .van-radio__icon.van-radio__icon--round .van-icon.van-icon-success::after,
  .van-icon.van-icon-success::before {
    content: ''
  }
}

.order_group.radio_group_over .van-radio__label {
  color: #999
}

.discounts-radio .van-hairline--top-bottom::after,
.discounts-radio .van-cell::after {
  border: 0;
}
</style>
